const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case 'SET_FIELD_VALUE':
      return {
        ...state,
        [action.name]: action.value,
      };
    case 'SET_FIELD_VALUES':
      return { ...state, ...action.values };
    case 'CLEAR_ENROLLMENT_VALUES':
      return initialState;
    case 'CLEAR_ENROLLMENT_FORM':
      return initialState;
    case 'CLEAR':
      return initialState;
    default:
      return state;
  }
}
